(function() {
  class MegaMenu extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;

    this.trigger = this.querySelector('[data-mega-menu-trigger]');
    this.panel = this.querySelector('[data-mega-menu-panel]');
    if (!this.trigger || !this.panel) return;

    this.initialized = true;
    this.closeTimer = null;
    this.onMouseEnter = this.open.bind(this);
    this.onMouseLeave = this.queueClose.bind(this);
    this.onFocusIn = this.open.bind(this);
    this.onFocusOut = this.handleFocusOut.bind(this);
    this.onTriggerClick = this.handleTriggerClick.bind(this);
    this.onKeyDown = this.handleKeyDown.bind(this);
    this.onDocumentClick = this.handleDocumentClick.bind(this);

    this.addEventListener('mouseenter', this.onMouseEnter);
    this.addEventListener('mouseleave', this.onMouseLeave);
    this.addEventListener('focusin', this.onFocusIn);
    this.addEventListener('focusout', this.onFocusOut);
    this.trigger.addEventListener('click', this.onTriggerClick);
    this.addEventListener('keydown', this.onKeyDown);
    document.addEventListener('click', this.onDocumentClick);
  }

  disconnectedCallback() {
    if (!this.initialized) return;

    this.removeEventListener('mouseenter', this.onMouseEnter);
    this.removeEventListener('mouseleave', this.onMouseLeave);
    this.removeEventListener('focusin', this.onFocusIn);
    this.removeEventListener('focusout', this.onFocusOut);
    this.trigger.removeEventListener('click', this.onTriggerClick);
    this.removeEventListener('keydown', this.onKeyDown);
    document.removeEventListener('click', this.onDocumentClick);
    this.initialized = false;
  }

  open() {
    window.clearTimeout(this.closeTimer);

    document.querySelectorAll('mega-menu[open]').forEach((menu) => {
      if (menu !== this) menu.close();
    });

    this.setAttribute('open', '');
    this.trigger.setAttribute('aria-expanded', 'true');
    this.panel.setAttribute('aria-hidden', 'false');
  }

  close() {
    window.clearTimeout(this.closeTimer);
    this.removeAttribute('open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.panel.setAttribute('aria-hidden', 'true');
  }

  queueClose() {
    window.clearTimeout(this.closeTimer);
    this.closeTimer = window.setTimeout(() => this.close(), 150);
  }

  handleFocusOut(event) {
    if (!this.contains(event.relatedTarget)) this.close();
  }

  handleTriggerClick(event) {
    const isPlaceholderLink = this.trigger.getAttribute('href') === '#';
    const isTouchNavigation = window.matchMedia('(hover: none)').matches;

    if (isPlaceholderLink || (isTouchNavigation && !this.hasAttribute('open'))) {
      event.preventDefault();
      this.hasAttribute('open') ? this.close() : this.open();
    }
  }

  handleDocumentClick(event) {
    if (!this.contains(event.target)) this.close();
  }

  handleKeyDown(event) {
    if (event.key === 'Escape') {
      this.close();
      this.trigger.focus();
      return;
    }

    if (event.key === 'ArrowDown' && event.target === this.trigger) {
      event.preventDefault();
      this.open();
      const firstLink = this.panel.querySelector('a');
      if (firstLink) firstLink.focus();
    }
  }
}

  if (!customElements.get('mega-menu')) {
    customElements.define('mega-menu', MegaMenu);
  }
})();
